module.exports = __webpack_public_path__ + "static/media/tech-back-vid.c77f6120.mp4";